import type { LanguageConfigurator } from "@components/Atoms/FileInput/languageConfig/monacoLanguageConfig";
import { conf, language as markdownLanguage } from "monaco-editor/esm/vs/basic-languages/markdown/markdown";

// Not `markdown`: Monaco's factory installs the stock grammar over ours when the first editor opens.
export const GRAMAX_MARKDOWN_LANGUAGE = "gramax-markdown";

// Containers indent by two spaces per level, so a body two levels deep would be painted as code.
const paintsIndentedTextAsCode = (rule: unknown) =>
	Array.isArray(rule) && rule[0] instanceof RegExp && rule[0].test("    plain text");

const paintsWholeHeaderCell = (rule: unknown) => Array.isArray(rule) && rule[1] === "keyword.table.header";

const GRAMAX_SIZE = /\{(width|height)=\d+px(\s+(width|height)=\d+px)*\}/;

export const configureMarkdownLanguage: LanguageConfigurator = (monaco) => {
	monaco.languages.register({ id: GRAMAX_MARKDOWN_LANGUAGE, extensions: [".md"], aliases: ["Markdown"] });
	monaco.languages.setLanguageConfiguration(GRAMAX_MARKDOWN_LANGUAGE, conf);
	monaco.languages.setMonarchTokensProvider(GRAMAX_MARKDOWN_LANGUAGE, {
		...markdownLanguage,
		tokenizer: {
			...markdownLanguage.tokenizer,
			root: markdownLanguage.tokenizer.root.filter((rule) => !paintsIndentedTextAsCode(rule)),
			linecontent: [[GRAMAX_SIZE, "attribute.name"], ...markdownLanguage.tokenizer.linecontent],
			// The stock grammar paints a header cell in one run; it has to stop at a brace for the size to show.
			table_header: [
				[GRAMAX_SIZE, "attribute.name"],
				...markdownLanguage.tokenizer.table_header.filter((rule) => !paintsWholeHeaderCell(rule)),
				[/[^|{]+/, "keyword.table.header"],
				[/\{/, "keyword.table.header"],
			],
		},
	});
};
